import { useLocation, useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import RegisterForm  from '../components/RegisterForm';
import { useState } from 'react';
import VerifyOTP from '@/components/Modals/verifyOTP';


export const Register = () => {
  const navigate = useNavigate();
  const [isOpen,setIsopen]= useState(false);
  const [email, setEmail]= useState('')
  const handleClose = () => {
    setIsopen(false);
  };

 
  const location = useLocation();
  const from = location.state?.from?.pathname || "/app/wallet/MyLottery?deposit=true";


 

  return (
    <Layout title="Register your account">
      <RegisterForm onSuccess={(email) => {setIsopen(true); setEmail(email)}} />
      <VerifyOTP open={isOpen} onClose={handleClose} email={email}  redirectPath={from}/>
    </Layout>
  );
};
